function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPanel = function SvgPanel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 128 2000",
    xmlSpace: "preserve",
    className: "main",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.754,770.178c0,0 21.942,-5.546 22.582,28.716c0.639,34.261 -21.4,29.312 -21.4,29.312l-1.182,-58.028Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.976,770.178c0,0 -21.942,-5.546 -22.582,28.716c-0.639,34.261 21.4,29.312 21.4,29.312l1.182,-58.028Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.465,754.985l0.91,86.884",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.506,755.031l-14.211,-12.819l0.095,-31.573l27.122,0.044l-0.157,31.711l-12.849,12.637Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.208,841.917l-14.115,12.924l0.33,31.572l27.121,-0.246l-0.393,-31.709l-12.943,-12.541Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.295,742.212l-35.016,0.042l-0.123,-28.08l16.403,-0.074l-0.023,10.962l-14.987,0.222",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.093,854.841l-35.015,0.218l0.086,28.081l16.403,-0.049l-0.105,-10.961l-14.988,-0.111",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.982,742.331l35.013,0.346l0.366,-28.079l-16.402,-0.215l-0.071,10.961l14.984,0.353",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.778,854.516l35.01,-0.606l0.575,28.075l-16.4,0.338l-0.153,-10.961l14.981,-0.463",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.158,78.208c0,0 21.943,-5.546 22.582,28.715c0.64,34.262 -21.399,29.313 -21.399,29.313l-1.183,-58.028Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.381,78.208c0,0 -21.943,-5.546 -22.582,28.715c-0.64,34.262 21.399,29.313 21.399,29.313l1.183,-58.028Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.869,63.014l0.911,86.885",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.91,63.061l-14.211,-12.819l0.096,-31.573l27.122,0.044l-0.158,31.71l-12.849,12.638Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.613,149.947l-14.116,12.924l0.331,31.571l27.121,-0.245l-0.394,-31.709l-12.942,-12.541Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.699,50.242l-35.015,0.042l-0.123,-28.08l16.403,-0.074l-0.023,10.961l-14.987,0.223",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.497,162.871l-35.014,0.218l0.085,28.08l16.403,-0.048l-0.104,-10.961l-14.988,-0.111",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.386,50.361l35.014,0.346l0.366,-28.079l-16.402,-0.215l-0.072,10.961l14.984,0.352",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.183,162.546l35.01,-0.606l0.574,28.075l-16.399,0.337l-0.154,-10.96l14.982,-0.464",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.265,1435.23c0,0 21.942,-5.546 22.582,28.716c0.639,34.261 -21.4,29.312 -21.4,29.312l-1.182,-58.028Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.487,1435.23c0,0 -21.942,-5.546 -22.582,28.716c-0.639,34.261 21.4,29.312 21.4,29.312l1.182,-58.028Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.976,1420.04l0.91,86.884",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.017,1420.09l-14.211,-12.819l0.095,-31.573l27.122,0.044l-0.157,31.711l-12.849,12.637Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.719,1506.97l-14.115,12.924l0.33,31.572l27.121,-0.246l-0.393,-31.708l-12.943,-12.542Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.806,1407.27l-35.016,0.042l-0.123,-28.08l16.403,-0.074l-0.023,10.962l-14.987,0.223",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.604,1519.9l-35.015,0.218l0.086,28.081l16.403,-0.049l-0.105,-10.961l-14.988,-0.111",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.493,1407.39l35.013,0.346l0.366,-28.079l-16.402,-0.215l-0.071,10.961l14.984,0.353",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.289,1519.57l35.01,-0.606l0.575,28.075l-16.4,0.338l-0.153,-10.961l14.981,-0.463",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.48,473.101l17.549,-0.287c0,0 -1.621,76.927 -4.283,80.63c-3.001,4.174 -41.558,2.317 -41.968,1.963c-2.661,-2.298 -1.211,-21.496 -0.549,-21.712c0,0 25.249,0.243 26.395,-1.891c1.145,-2.134 2.856,-58.703 2.856,-58.703Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.677,642.502l-16.882,0.226c0,0 2.378,-79.19 5.04,-82.893c3,-4.173 43.236,-2.687 43.646,-2.333c2.662,2.297 2.156,18.664 1.494,18.881c0,0 -25.29,-1.429 -29.082,2.291c-4.478,4.393 -4.216,63.828 -4.216,63.828Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.149,471.363l17.139,0.599c0,0 0.44,35.367 -2.49,40.48c-3.413,5.955 -14.5,5.283 -14.648,4.401c-0.288,-1.712 -0.001,-45.48 -0.001,-45.48Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.32,640.807l-19.581,0.165c0,0 -1.262,-44.422 0.337,-45.598c1.821,-1.338 18.783,-1.144 18.931,-0.262c0.288,1.712 0.313,45.695 0.313,45.695Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.588,608.947c0,0 22.118,3.221 11.425,27.009c-3.269,7.273 -13.785,4.475 -13.785,4.475c0,0 0.38,-65.369 5.458,-65.093c1.349,0.074 17.405,-1.896 24.16,4.453c10.014,9.413 5.602,61.815 5.602,61.815c0,0 0.8,-41.321 -0.123,-45.527c-1.897,-8.653 -31.968,-12.626 -32.993,-7.459",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.374,504.68c0,0 -10.324,0.613 -12.567,-0.043c-5.376,-1.573 -6.149,-26.64 -3.255,-32.144c1.944,-3.699 16.684,-1.286 16.684,-1.286c0,0 0.776,65.584 -4.303,65.308c-1.349,-0.073 -23.247,5.253 -25.26,-3.795c-2.076,-9.333 0.206,-59.252 -1.045,-60.724c0,0 0.422,40.219 1.344,44.425c1.898,8.653 26.135,11.764 27.16,6.597",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.264,1149.67l17.549,-0.287c0,0 -1.621,76.927 -4.284,80.63c-3,4.174 -41.557,2.317 -41.967,1.963c-2.661,-2.298 -1.211,-21.495 -0.549,-21.712c0,0 25.249,0.243 26.395,-1.891c1.145,-2.134 2.856,-58.703 2.856,-58.703Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.461,1319.07l-16.882,0.225c0,0 2.378,-79.19 5.04,-82.893c3,-4.173 43.236,-2.687 43.646,-2.333c2.661,2.297 2.156,18.664 1.494,18.881c0,0 -25.29,-1.429 -29.082,2.291c-4.478,4.393 -4.216,63.829 -4.216,63.829Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.932,1147.93l17.139,0.599c0,0 0.44,35.367 -2.489,40.48c-3.413,5.955 -14.5,5.283 -14.648,4.401c-0.288,-1.712 -0.002,-45.48 -0.002,-45.48Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.104,1317.38l-19.582,0.165c0,0 -1.261,-44.421 0.338,-45.598c1.821,-1.338 18.783,-1.144 18.931,-0.262c0.288,1.712 0.313,45.695 0.313,45.695Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.371,1285.52c0,0 22.119,3.221 11.426,27.008c-3.269,7.273 -13.785,4.475 -13.785,4.475c0,0 0.379,-65.368 5.458,-65.092c1.349,0.073 17.405,-1.896 24.16,4.452c10.014,9.413 5.602,61.815 5.602,61.815c0,0 0.799,-41.321 -0.123,-45.527c-1.897,-8.653 -31.968,-12.626 -32.993,-7.459",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.158,1181.25c0,0 -10.325,0.612 -12.567,-0.044c-5.377,-1.573 -6.149,-26.64 -3.256,-32.144c1.945,-3.699 16.685,-1.285 16.685,-1.285c0,0 0.776,65.583 -4.303,65.307c-1.349,-0.073 -23.247,5.253 -25.26,-3.795c-2.076,-9.333 0.206,-59.252 -1.046,-60.724c0,0 0.423,40.219 1.345,44.425c1.898,8.653 26.135,11.764 27.16,6.597",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.264,1805.99l17.549,-0.287c0,0 -1.621,76.927 -4.284,80.63c-3,4.174 -41.557,2.317 -41.967,1.963c-2.661,-2.298 -1.211,-21.495 -0.549,-21.712c0,0 25.249,0.243 26.395,-1.891c1.145,-2.134 2.856,-58.703 2.856,-58.703Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.461,1975.4l-16.882,0.225c0,0 2.378,-79.19 5.04,-82.893c3,-4.173 43.236,-2.687 43.646,-2.333c2.661,2.297 2.156,18.664 1.494,18.881c0,0 -25.29,-1.429 -29.082,2.291c-4.478,4.393 -4.216,63.829 -4.216,63.829Z",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.932,1804.26l17.139,0.6c0,0 0.44,35.366 -2.489,40.479c-3.413,5.955 -14.5,5.283 -14.648,4.401c-0.288,-1.712 -0.002,-45.48 -0.002,-45.48Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.104,1973.7l-19.582,0.164c0,0 -1.261,-44.421 0.338,-45.597c1.821,-1.339 18.783,-1.145 18.931,-0.263c0.288,1.712 0.313,45.696 0.313,45.696Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.371,1941.84c0,0 22.119,3.221 11.426,27.008c-3.269,7.273 -13.785,4.475 -13.785,4.475c0,0 0.379,-65.368 5.458,-65.092c1.349,0.073 17.405,-1.896 24.16,4.452c10.014,9.413 5.602,61.815 5.602,61.815c0,0 0.799,-41.321 -0.123,-45.527c-1.897,-8.653 -31.968,-12.626 -32.993,-7.459",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.158,1837.57c0,0 -10.325,0.612 -12.567,-0.044c-5.377,-1.573 -6.149,-26.64 -3.256,-32.144c1.945,-3.699 16.685,-1.285 16.685,-1.285c0,0 0.776,65.583 -4.303,65.307c-1.349,-0.073 -23.247,5.253 -25.26,-3.795c-2.076,-9.333 0.206,-59.252 -1.046,-60.724c0,0 0.423,40.219 1.345,44.425c1.898,8.653 26.135,11.764 27.16,6.597",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.676,253.312c0,0 2.291,33.349 -6.113,40.71c-8.404,7.362 -18.699,8.716 -18.699,8.414c0,-0.302 -1.22,-49.629 -1.22,-49.629l41.446,0.803l0.259,71.933l-34.378,0.542l0.584,23.606c-0.723,2.938 14.062,-5.23 26.802,5.363c10.333,8.591 7.586,45.435 6.569,44.948l-37.053,1.919l0.046,-24.942l15.247,-0.688l-0.013,24.839c0,0 21.45,-1.44 21.773,-1.128c0.323,0.313 5.904,-31.611 -6.569,-44.948c-12.23,-13.078 -27.47,-2.497 -26.802,-5.363c0,0 -0.423,-26.612 -0.584,-23.606c-0.161,3.006 25.214,-9.915 29.017,-17.92c5.604,-11.796 5.862,-50.443 5.102,-54.555l-15.414,-0.298Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.487,402.959c0,0 -2.888,-30.851 4.108,-40.822c3.663,-5.221 20.255,-8.613 20.255,-8.311c0,0.302 1.219,49.629 1.219,49.629l-41.445,-0.803l-0.259,-71.933l34.378,-0.542l-0.585,-23.606c0.724,-2.937 -14.062,5.23 -26.801,-5.362c-10.333,-8.591 -7.586,-45.436 -6.569,-44.949l37.053,-1.918l-0.047,24.941l-15.246,0.688l0.013,-24.838c0,0 -21.45,1.44 -21.773,1.127c-0.324,-0.312 -5.904,31.612 6.569,44.949c12.229,13.077 27.469,2.496 26.801,5.362c0,0 0.761,23.702 0.585,23.606c-1.955,-1.058 -18.948,1.7 -27.183,12.754c-8.03,10.781 -7.696,55.61 -6.936,59.721l15.863,0.307Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.326,325.881c-0.523,-0.035 16.217,0.324 20.103,32.605c1.041,8.645 5.802,-25.322 0.175,-28.031c-5.628,-2.709 -17.797,-17.496 -18.634,-39.602c-0.836,-22.105 -1.121,35.064 -1.644,35.028Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.262,942.392c0,0 2.291,33.349 -6.113,40.71c-8.404,7.361 -18.699,8.716 -18.699,8.414c0,-0.302 -1.22,-49.629 -1.22,-49.629l41.446,0.803l0.259,71.933l-34.378,0.542l0.584,23.606c-0.723,2.937 14.062,-5.23 26.802,5.362c10.333,8.591 7.586,45.436 6.569,44.949l-37.053,1.918l0.046,-24.941l15.247,-0.688l-0.013,24.838c0,0 21.45,-1.44 21.773,-1.127c0.323,0.312 5.904,-31.612 -6.569,-44.949c-12.23,-13.077 -27.47,-2.496 -26.802,-5.362c0,0 -0.423,-26.612 -0.584,-23.606c-0.161,3.006 25.214,-9.915 29.017,-17.92c5.605,-11.797 5.862,-50.444 5.102,-54.555l-15.414,-0.298Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.073,1092.04c0,0 -2.888,-30.851 4.108,-40.822c3.663,-5.222 20.255,-8.613 20.255,-8.311c0,0.302 1.219,49.629 1.219,49.629l-41.445,-0.803l-0.259,-71.934l34.378,-0.541l-0.585,-23.606c0.724,-2.938 -14.062,5.23 -26.801,-5.363c-10.333,-8.591 -7.586,-45.435 -6.569,-44.948l37.053,-1.919l-0.047,24.942l-15.246,0.688l0.013,-24.839c0,0 -21.45,1.44 -21.773,1.128c-0.323,-0.313 -5.904,31.611 6.569,44.948c12.229,13.078 27.469,2.497 26.801,5.363c0,0 0.761,23.702 0.585,23.606c-1.955,-1.059 -18.948,1.7 -27.183,12.754c-8.03,10.781 -7.696,55.609 -6.936,59.721l15.863,0.307Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.912,1014.96c-0.523,-0.036 16.217,0.323 20.103,32.604c1.041,8.646 5.802,-25.322 0.175,-28.03c-5.628,-2.709 -17.797,-17.496 -18.634,-39.602c-0.836,-22.105 -1.121,35.064 -1.644,35.028Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.262,1599.8c0,0 2.291,33.349 -6.113,40.71c-8.404,7.361 -18.699,8.716 -18.699,8.414c0,-0.302 -1.22,-49.629 -1.22,-49.629l41.446,0.803l0.259,71.933l-34.378,0.542l0.584,23.606c-0.723,2.938 14.062,-5.23 26.802,5.362c10.333,8.591 7.586,45.436 6.569,44.949l-37.053,1.919l0.046,-24.942l15.247,-0.688l-0.013,24.838c0,0 21.45,-1.44 21.773,-1.127c0.323,0.312 5.904,-31.611 -6.569,-44.949c-12.23,-13.077 -27.47,-2.496 -26.802,-5.362c0,0 -0.423,-26.612 -0.584,-23.606c-0.161,3.006 25.214,-9.915 29.017,-17.92c5.605,-11.797 5.862,-50.444 5.102,-54.555l-15.414,-0.298Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.073,1749.44c0,0 -2.888,-30.851 4.108,-40.822c3.663,-5.221 20.255,-8.613 20.255,-8.311c0,0.302 1.219,49.629 1.219,49.629l-41.445,-0.803l-0.259,-71.933l34.378,-0.542l-0.585,-23.606c0.724,-2.938 -14.062,5.23 -26.801,-5.363c-10.333,-8.591 -7.586,-45.435 -6.569,-44.948l37.053,-1.919l-0.047,24.942l-15.246,0.688l0.013,-24.838c0,0 -21.45,1.439 -21.773,1.127c-0.323,-0.313 -5.904,31.611 6.569,44.948c12.229,13.078 27.469,2.497 26.801,5.363c0,0 0.761,23.702 0.585,23.606c-1.955,-1.059 -18.948,1.7 -27.183,12.754c-8.03,10.781 -7.696,55.609 -6.936,59.721l15.863,0.307Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.912,1672.36c-0.523,-0.036 16.217,0.323 20.103,32.604c1.041,8.646 5.802,-25.321 0.175,-28.03c-5.628,-2.709 -17.797,-17.496 -18.634,-39.602c-0.836,-22.105 -1.121,35.064 -1.644,35.028Z",
    className: "main",
    style: {
      strokeWidth: "3.5px"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPanel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/panel.de80a1bc.svg";
export { ForwardRef as ReactComponent };